import React from 'react';
import {BottoneFinePagina} from "../bottoni/BottoneFinePagina";
import {BottoneInizioPagina} from "../bottoni/BottoneInizioPagina";
import {Button, Grid, Table, TableBody, TableCell, TableHead, TableRow} from "@mui/material";

export default class TableCtrNeg extends React.Component {
    constructor(props) {
        super(props);
        this.getHeader = this.getHeader.bind(this);
        this.getRowsData = this.getRowsData.bind(this);
    }

    getKeys = () => Object.keys(this.props.data[0] || {});

    getHeader = () => {
        return this.getKeys().map((key) => (
            <TableCell key={key} align="center" style={styles.headerCell}>
                <b>{key.toUpperCase()}</b>
            </TableCell>
        ));
    };

    getRowsData = () => {
        return this.props.data.map((row, index) => (
            <TableRow hover key={index}>
                <RenderRow data={row} keys={this.getKeys()}/>
            </TableRow>
        ));
    };

    display = () => window.print();

    render() {

        try {
            return (
                <Grid container direction="column" spacing={2}>
                    <Grid item>Risultati: {this.props.data.length}</Grid>
                    <Grid item><BottoneFinePagina/></Grid>
                    <Grid item>
                        <Table stickyHeader>
                            <TableHead><TableRow>{this.getHeader()}</TableRow></TableHead>
                            <TableBody>{this.getRowsData()}</TableBody>
                        </Table>
                    </Grid>
                    <Grid item>
                        <Grid container direction="row" spacing={3}>
                            <Grid item><BottoneInizioPagina/></Grid>
                            <Grid item>
                                <Button variant="contained" onClick={this.display}>STAMPA</Button>
                            </Grid>
                        </Grid>
                    </Grid>


                </Grid>
            )
        } catch (e) {
            return (
                <Grid container direction="column" spacing={2}>
                </Grid>)
        }

    }
}

const RenderRow = ({data, keys}) => {
    return keys.map((key, index) => (
        <TableCell key={index} align={getAlignment(key)} style={styles.cell}>
            {formatText(data[key])}
        </TableCell>
    ));
};

const getAlignment = (key) => {
    return ["DESCRIZIONE", "EAN"].includes(key.toUpperCase()) ? "left" : "right";
};

const formatText = (text) => {
    if (typeof text !== "string") return text;
    if (text.startsWith("_B_")) return <b>{text.replace("_B_", "")}</b>;
    if (text.startsWith("_BR_")) return <b style={{color: "red"}}>{text.replace("_BR_", "")}</b>;
    return text;
};

const styles = {
    headerCell: {
        backgroundColor: "#ECECFB",
        border: "1px solid gray",
    },
    cell: {
        border: "1px solid gray",
    },
};


